import type { ReactNode } from 'react';

interface Props {
  /** The card's question / caption, e.g. "Which route? · Age", "Runs alongside". */
  title: string;
  children: ReactNode;
}

/**
 * The frame for a sequence fork the campaign timeline has no card for (a switch's routes, a spawn's lane) —
 * the same chrome as the campaign's "Did the contact accept the invitation?" card, so a sequence reads in one
 * visual language from top to bottom.
 */
export function SequenceTimelineCard({ title, children }: Props) {
  return (
    <div
      data-sequence-timeline-card={title}
      className="flex w-full flex-col overflow-hidden rounded-lg border border-lynch-200 bg-white shadow-xs dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-lynch-200 px-3 py-2 dark:border-slate-800">
        <span className="text-xs font-semibold uppercase tracking-wide text-lynch-700 dark:text-lynch-300">
          {title}
        </span>
      </div>
      <div className="flex flex-col divide-y divide-lynch-200 dark:divide-slate-800">{children}</div>
    </div>
  );
}
